import { useViewerHasAtLeastLogisticianRights } from "@/lib/rights/use-viewer-has-right";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";
import useTranslation from "@babackapp/translations/use-translation";
import { Trash } from "lucide-react";

export function useCancelAction(onClick: () => void) {
  const t = useTranslation();
  const hasLogisticianRight = useViewerHasAtLeastLogisticianRights();
  const returnRequest = useCurrentReturnRequest();
  const approvedAlready = returnRequest.status.approved.done;
  const hasBeenTreatedByMerchant = returnRequest.status.treatedMerchant.done;
  const isCancelled = returnRequest.status.cancelled.done;

  return {
    label: t("misc.cancel"),
    icon: <Trash className="h-5 w-5 text-destructive" />,
    enabled:
      hasLogisticianRight &&
      !hasBeenTreatedByMerchant &&
      approvedAlready &&
      !isCancelled,
    onClick,
  };
}
